import React from "react";
import { FaLinkedin } from "react-icons/fa";
import Saurabh from "../../../../assets/images/Saurabh-Image.jpg";
import Keshav from "../../../../assets/images/Keshav-image.jpeg";
import Yogesh from "../../../../assets/images/yogesh-image.jpeg";
// import Team from "./components/Team/Team";

const teamMembers = [
  {
    name: "Saurabh Shukla",
    role: "",
    image: Saurabh,
    linkedIn:
      "https://www.linkedin.com/",
  },
  {
    name: "Keshav Gupta",
    role: "",
    image: Keshav,
    linkedIn:
      "https://www.linkedin.com/in/keshav-gupta-035a4214b/",
  },
  {
    name: "Yogesh Kumar",
    role: "",
    image: Yogesh,
    linkedIn:
      "https://www.linkedin.com/in/yogesh9643?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAACd2dhEByoB4td8DZn6DYoDV7uiR6Vu5lg0&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BnFHW3VBgRt6oNSA2F1e0bQ%3D%3D",
  },
];

const Teams = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="mb-20">

          <div className="mx-auto max-w-2xl lg:text-center">
            <h2 className="text-base font-semibold leading-7 text-indigo-600">Leadership</h2>
            <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Meet Our Team</p>
            <p className="mt-6 text-lg leading-8 text-gray-600">Our leadership team combines extensive expertise in AI, security, and enterprise solutions, delivering innovative strategies and proven results to drive success.</p>
            <br></br>
            <br></br>
          </div>
        <div className="grid md:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="text-center relative">
              <a
                href={member.linkedIn}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-48 h-48 rounded-full mx-auto mb-4 object-cover"
                />
              </a>
              <h3 className="text-xl font-semibold">{member.name}</h3>
              <p className="text-gray-600">{member.role}</p>
              <a
                href={member.linkedIn}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 inline-flex items-center justify-center text-blue-700"
              >
                <FaLinkedin className="mr-1" />
              </a>
            </div>
          ))}
        </div>
        
      </div>
    </div>
  );
};

export default Teams;
